<template>
    <b-modal
        ref="modalEditNote"
        title-tag="h2"
        title="Edit Note"
        :lazy="true"
        @ok="editNote()"
        ok-title="Save"
        :ok-disabled="isOkDisabled"
        footer-class="d-flex justify-content-between"
    >
        <form ref="form" name="new-form" @submit.stop.prevent="submitForm()">
            <b-form-group label-for="title" label="Title" label-cols="4">
                <b-form-input
                    id="title"
                    v-model="content"
                    :class="{ 'border-danger': errors.has('title') }"
                    v-validate="'required'"
                    placeholder="Title (required)"
                    name="title"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                label-for="notification"
                label="Notification"
                label-cols="4"
            >
                <b-form-select
                    v-model="notificationId"
                    :options="notifications"
                    value-field="id"
                    text-field="text"
                    name="notification"
                ></b-form-select>
            </b-form-group>
            <b-form-group label-for="note" label="Note" label-cols="4">
                <b-form-textarea
                    v-model="noteDetails"
                    placeholder="Note"
                    rows="3"
                    name="note"
                ></b-form-textarea>
            </b-form-group>
        </form>
    </b-modal>
</template>
<script type="text/javascript">
import Notes from "@/services/contact-notes";
import { clone } from "lodash";

export default {
    props: {
        contactId: {
            type: String,
            required: true
        },
        note: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            notifications: [
                { id: 0, text: "Profile Only" },
                { id: 1, text: "Pop-up" }
            ],
            content: null,
            notificationId: null,
            noteDetails: null
        };
    },
    computed: {
        isOkDisabled() {
            return Object.keys(this.fields).some(
                key => this.fields[key].invalid
            );
        }
    },
    methods: {
        open() {
            this.$refs.modalEditNote.show();

            this.$nextTick(() => {
                this.content = clone(this.note.title);
                this.notificationId = clone(this.note.notification.id);
                this.noteDetails = clone(this.note.note);
            });
        },
        submitForm() {
            if (!this.isOkDisabled) {
                this.editNote();
            }
        },
        editNote() {
            let params = {
                title: this.content,
                note: this.noteDetails,
                notification: this.notificationId
            };

            const contactId = this.note.id;

            Notes.editNote(contactId, params)
                .then(response => {
                    if (response.message.code === 200) {
                        this._message("Note successfully edited");
                        this.$store
                            .dispatch(
                                "contact/loadPopupNotes",
                                this.$store.state.contact.contactId
                            )
                            .then(() => {
                                this.$store.commit("contact/updatePopupKey");
                            });
                        this.$emit("reload");
                    } else {
                        this.showError();
                    }
                })
                .catch(error => {
                    this.showError();
                    console.error(error);
                });
        },
        showError() {
            this._message("Error : Unable to edit note", "danger");
        }
    }
};
</script>
